import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {Dossier} from '../../../class/api/Dossier';
import {HydraService} from '../../../core/services/hydra.service';
import {ToolsService} from '../../services/tools/tools.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-aide-financement',
    templateUrl: './modal-aide-financement.component.html',
    styleUrls: ['./modal-aide-financement.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatDialogActions, MatButton, TranslateModule]
})
export class ModalAideFinancementComponent {
    toolService = inject(ToolsService);
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalAideFinancementComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);

    public dossier: Dossier = null;
    public texte: any = null;
    public sommaire = [];

    VoirId: number = null;
    public langue = 'fr';

    constructor() {
        this.loadHTML();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    loadHTML() {
        const url = '/fr/aides/financement/'+this.data.id + '?fullHtml=true';

        this.hydraService.getHtml(url).subscribe(
            res => {
                this.texte = res;
                this.editHtml();
            },
            err => {}
        );
    }

    editHtml() {
        if (document.getElementById('iframeViwewer')) {
            document.getElementById('iframeViwewer').remove();
        }

        this.sommaire = [];
        const iframe = document.createElement('iframe');
        let html = this.texte;
        html = html.replace('class="container"','');
        html = html.replace('<html>','<html style="overflow: hidden">');
        document.getElementById('content').appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);
        iframe.contentWindow.document.close();
        iframe.setAttribute('id', 'iframeViwewer');
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('style', 'border:none; display:block;');

        window.setTimeout(() => {
            iframe.setAttribute(
                'min-height',
                iframe.contentWindow.document.body.scrollHeight + 'px'
            );
            iframe.setAttribute(
                'height',
                iframe.contentWindow.document.body.scrollHeight + 'px'
            );
            const titres = iframe.contentWindow.document.getElementsByTagName(
                'h3'
            ) as any;
            for (let i = 0; i < titres.length; i++) {
                const item = titres[i] as HTMLElement;
                const id = this.toolService.getGUID();
                item.setAttribute('id', id);
                this.sommaire.push({
                    scrollTo: item.offsetTop,
                    label: item.innerText,
                });
            }
        }, 500);
    }

    public scrollToLink(index: number) {
        window.scroll({
            top: index,
            left: 0,
            behavior: 'smooth',
        });
    }

    public valideFinancement(): void {
        this.dialogRef.close(true);
    }
}
